export enum SystemApplicationEnum {
  Parts = 1,
  Claims = 2
}
